<template>
  <v-app id="Gbmt1">
    <v-main>
      <v-container fluid>
      <v-row>
         <v-col cols="2">
            <v-menu
              v-model="dat1menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.van_dat" 
              label="No ledger mutation <= date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.van_dat2" :first-day-of-week="1" @input="param.van_dat = $moment(param.van_dat2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
            </v-menu>  
          </v-col>

      </v-row>  
     

      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="submitted" @click="ovrz">Save date</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      dat1menu: false,
      hulpDate: '',
      submitted: false,
      param: {}
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/fin/exact/getAfsluit1Param.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getAfsluit1Param"
        },
        getAfsluit1Param: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getAfsluit1Param; 
           res.data.getAfsluit1Param.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.submitted = true;
      this.$axios
        .post("ares/json/ares/task/fin/exact/afsluit1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "afsluit1"
          },
          afsluit1: {
            van_dat: this.param.van_dat

          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            /* this.items = res.data.afsluit1; */
            this.submitted = false;
            /*
            if (typeof(this.items.filename) !== "undefined" && this.items.filename) {
               window.open(this.items.filename,'_blank');
            }
            */
          

            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.afsluit1.text,
              color: res.data.afsluit1.color,
            });
            setTimeout(() => { this.$router.push("/empty"); }, 5000); 


          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
